import React from 'react'
import PropTypes from 'prop-types'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import Tooltip from '@material-ui/core/Tooltip'

import variables from 'tools/variables'

import ValidationError from 'components/forms/ValidationError'

import styles from './BaseDropdown.module.scss'

const BaseDropdown = ({
  label,
  name,
  id,
  className,
  disabled,
  required,
  error,
  tooltip,
  children,
  style
}) => {
  return (
    <FormControl
      className={`${styles.baseDropdownRoot} ${label ? styles.withLabel : ''} ${className}`}
      style={style}
      disabled={disabled}
      required={required}
      error={!!error}
    >
      {/* The label used to render only once a value was selected, and then as
          an absolutely-positioned notch on the border. It now always sits
          above the control, matching the DS Field used by the inputs. */}
      {label && (
        <InputLabel
          shrink
          className={`${styles.inputLabel} ${error ? styles.labelError : ''}`}
          htmlFor={id || name}
        >
          {label}
        </InputLabel>
      )}
      {tooltip ? (
        <Tooltip
          title={tooltip.title}
          placement={tooltip.placement}
          enterDelay={variables.tooltipDelayMs}
          disableFocusListener
          disableTouchListener
        >
          {children}
        </Tooltip>
      ) : (
        children
      )}
      <ValidationError error={error} />
    </FormControl>
  )
}

BaseDropdown.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  error: PropTypes.string,
  tooltip: PropTypes.object,
  children: PropTypes.node // react-select Dropdown or AsyncDropdown
}

export default BaseDropdown
